import { PortableText } from "@portabletext/react";
import { default as dynamicImport } from "next/dynamic";

import Image from "@/components/Image";
import HeroContent from "@/components/HeroContent";

const ContentSwiper = dynamicImport(() => import("@/components/ContentSwiper"), {
  ssr: true,
});

const BeforeAfterSlider = dynamicImport(() => import("@/components/BeforeAfterSlider"), {
  ssr: true,
});

const GithubLink = dynamicImport(() => import("@/components/GithubLink"), {
  ssr: true,
});

export const getComponents = (additionalData) => {
  const serializer = {
    marks: {
      highlight: ({ children }) => <span className="highlight">{children}</span>,
    },
    types: {
      columns: ({ value }) => {
        return (
          <div className="block-content-grid">
            {value.columns.map(({ column }) => (
              <div className="block-content-column">
                <BlockContent body={column}></BlockContent>
              </div>
            ))}
          </div>
        );
      },
      photo: ({ value }) => (
        <div className="_photo">
          <Image src={value.asset} alt="" className="h-full" />

          <BlockContent body={value.caption}></BlockContent>
        </div>
      ),
      // gallery: ({ value }) => <Gallery {...value} />,
      gallery: ({ value }) => {
        throw new Error("block content: gallery missing");
      },
      beforeAfterSlider: ({ value }) => (
        <div className="mb-12">
          <BeforeAfterSlider
            before={<Image src={value.beforeImage} />}
            after={<Image src={value.afterImage} />}
            beforeCaption={value.beforeImage?.caption}
            afterCaption={value.afterImage?.caption}
          />
          <div className="mt-2 text-sm text-center text-gray-600">
            <BlockContent body={value.caption} serializers={getComponents()} />
          </div>
        </div>
      ),
      mediaSlider: ({ value }) => (
        <div className="mb-12">
          <ContentSwiper caption={value.caption} navPosition={value.navPosition} autoHeight>
            {value.photos.map((photo) => (
              <Image src={photo} />
            ))}
          </ContentSwiper>
        </div>
      ),
      heroContent: ({ value }) => (
        <div className="my-32">
          <HeroContent {...value} />
        </div>
      ),
      // div: ({ value }) => <Div {...value}></Div>,
      div: ({ value }) => {
        throw new Error("block content: gallery missing");
      },
      githubUrl: ({ value }) => <GithubLink url={value.url}></GithubLink>,
      infoBlock: ({ value }) => (
        <div className="info-block bg-blue-50">
          <span className="infoblock-block text-xl font-bold mb-3">{value.title}:</span>

          <BlockContent body={value.body} serializers={getComponents({ isInfoBlock: true })} />
        </div>
      ),
      richList: ({ value }) => (
        <ul className="rich-list ml-0! list-none">
          {value.items.map(({ title, content, emoji, _key }) => (
            <li key={_key} className="flex">
              <span className="w-6 shrink-0">{emoji}</span>
              <div>
                <h4 className="mt-0!">{title}</h4>
                <BlockContent body={content} serializers={getComponents()} />
              </div>
            </li>
          ))}
        </ul>
      ),
    },
    block: {
      normal: ({ value, children, ...props }) => {
        const { markDefs } = value;

        const style = {};

        const colorDef = markDefs.find(({ _type }) => _type === "color");

        if (colorDef) {
          style.color = colorDef.hex;
        }

        return <p style={style}>{children}</p>;
      },
      "lg-center": ({ children, ...props }) => {
        throw new Error("block content: lg-center missing");
      },
      "lg-left": ({ children, ...props }) => {
        throw new Error("block content: lg-left missing");
      },
      // TODO
      // a: ... make it recognize modals
    },
  };

  return serializer;
};

const BlockContent = ({ body, project = null }) => (
  <div className="block-content">
    <PortableText
      value={body}
      components={getComponents({ project })}
      onMissingComponent={(message, options) => {
        // console.log(message, {
        //   // eg `someUnknownType`
        //   type: options.type,
        //   // 'block' | 'mark' | 'blockStyle' | 'listStyle' | 'listItemStyle'
        //   nodeType: options.nodeType,
        // });
      }}
    />
  </div>
);

export default BlockContent;
